<div class="header">
    <img src="https://fodimi.pl/img/site_logo/logo_4.png">
</div>
    <div class="content-container">
        <h3>{{ 'AUTH.CONTACT_FORM_TITLE' | translate }}</h3>
        <div class="cards-list">
            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.FISCALIZATION)" (click)="toggleModule(SubscriptionModuleEnum.FISCALIZATION)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/fiskal.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_FISCALIZATION' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.WEBSITE)" (click)="toggleModule(SubscriptionModuleEnum.WEBSITE)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/www.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_WEBSITE' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.MOBILE_APP)" (click)="toggleModule(SubscriptionModuleEnum.MOBILE_APP)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/mobile.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_MOBILE' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.QR_MENU_TABLE_ORDER)" (click)="toggleModule(SubscriptionModuleEnum.QR_MENU_TABLE_ORDER)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/qrmenu.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_QR' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.KDS)" (click)="toggleModule(SubscriptionModuleEnum.KDS)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/kds.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_KDS' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.INVENTORY)" (click)="toggleModule(SubscriptionModuleEnum.INVENTORY)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/magazyn.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_INVENTORY' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.DRIVER)" (click)="toggleModule(SubscriptionModuleEnum.DRIVER)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/fast-delivery.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_DRIVER' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="isModuleSelected(SubscriptionModuleEnum.KIOSK)" (click)="toggleModule(SubscriptionModuleEnum.KIOSK)">
                <div class="card-body">
                    <img src="https://fodimi.pl/img/icons/kiosk.png">
                    <h5>{{ 'AUTH.CONTACT_FORM_MODULE_KIOSK' | translate }}</h5>
                </div>
            </div>

        </div>

    </div>
    <div class="content-container">
        <h3>{{ 'AUTH.CONTACT_FORM_TYPE_TITLE' | translate }}</h3>
        <div class="cards-list">
            <div class="card" [class.active]="formData.typeSelected === 'RESTAURANT'" (click)="formData.typeSelected = 'RESTAURANT'">
                <div class="card-body">
                    <img src="assets/img/spaghetti.svg">
                    <h5>{{ 'AUTH.CONTACT_FORM_TYPE_RESTAURANT' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'FOODTRACK'" (click)="formData.typeSelected = 'FOODTRACK'">
                <div class="card-body">
                    <img src="assets/img/pizza.svg">
                    <h5>{{ 'AUTH.CONTACT_FORM_TYPE_FOODTRACK' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'BAKERY'" (click)="formData.typeSelected = 'BAKERY'">
                <div class="card-body">
                    <img src="assets/img/pie.svg">
                    <h5>{{ 'AUTH.CONTACT_FORM_TYPE_BAKERY' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'CAFFE'" (click)="formData.typeSelected = 'CAFFE'">
                <div class="card-body">
                    <img src="assets/img/salmon.svg">
                    <h5>{{ 'AUTH.CONTACT_FORM_TYPE_CAFFE' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'BAR'" (click)="formData.typeSelected = 'BAR'">
                <div class="card-body">
                    <img src="assets/img/burger.svg">
                    <h5>{{ 'AUTH.CONTACT_FORM_TYPE_BAR' | translate }}</h5>
                </div>
            </div>

            <div class="card" [class.active]="formData.typeSelected === 'OTHER'" (click)="formData.typeSelected = 'OTHER'">
                <div class="card-body">
                    <img src="assets/img/taco.svg">
                    <h5>{{ 'AUTH.CONTACT_FORM_TYPE_OTHER' | translate }}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="content-container form-elem">
        <h3>{{ 'AUTH.CONTACT_FORM_DATA_TITLE' | translate }}</h3>
        <div class="form mt-3">
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" [(ngModel)]="formData.name" [ngClass]="{ 'is-invalid':submitted && !formData.name}">
                    <label>{{ 'AUTH.CONTACT_FORM_NAME' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" [(ngModel)]="formData.phone"  [ngClass]="{ 'is-invalid':submitted && !formData.phone}">
                    <label>{{ 'INIT_WIZARD.PHONE_NUMBER' | translate }}</label>
                </div>
            </div>
            <div class="form-floating mb-3">
                <div class="form-floating mb-1">
                    <input class="form-control" [(ngModel)]="formData.email"  [ngClass]="{ 'is-invalid':submitted && !formData.email}">
                    <label>{{ 'AUTH.CONTACT_FORM_EMAIL' | translate }}</label>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-check">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="formData.havePOS">
                        {{ 'AUTH.CONTACT_FORM_HAS_POS' | translate }}</label>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-check">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="formData.terms"  [ngClass]="{ 'is-invalid':submitted && !formData.terms}">
                        {{ 'AUTH.CONTACT_FORM_TERMS_PREFIX' | translate }} <a href="https://fodimi.pl/dokumenty/regulamin" target="_blank">{{ 'AUTH.CONTACT_FORM_TERMS_LINK' | translate }}</a></label>
                </div>
            </div>
        </div>
        <div class="text-center">
            <button class="btn btn-primary" (click)="save()">{{ 'AUTH.CONTACT_FORM_SUBMIT' | translate }}</button>
            <a  href="https://fodimi.pl"><button class="ml-2 btn btn-outline-primary">{{ 'AUTH.BACK_TO_HOME' | translate }}</button></a>
        </div>
    </div>
